import { Box, Typography } from "@mui/material";
import logoIcon from "../../assets/images/logo-icon.svg";
import instagramIcon from "../../assets/images/instagram.svg";
import telegramIcon from "../../assets/images/telegram.svg";
import linkedinIcon from "../../assets/images/linkedin.svg";
import arrowUpIcon from "../../assets/images/arrow-up.svg";


import useUserStore from "../../store/useUserStore";

export default function Footer({ onScrollTo }) {

  const windowInnerWidth = useUserStore((state) => state.windowInnerWidth);
  const isMobile = windowInnerWidth < 960;



  return (
    <footer
      style={{
        width: "100%",
        minHeight: "276px",
        backgroundColor: "rgba(11, 25, 62, 0.05)",
        display: "flex",
        justifyContent: "center",
        padding: windowInnerWidth < 960 ? "0 20px" : "0 80px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: isMobile ? "column" : "row",
          width: "100%",
          minHeight: "276px",
          maxWidth: "1200px",
          py: "40px",
          borderTop: isMobile ? "1px solid rgba(255, 255, 255, 0.1)" : "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: "100%",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: isMobile ? "center" : "flex-start",
          }}
        >
          {!isMobile && (
            <Box
              component={"img"}
              src={logoIcon}
              alt="logo icon"
              width="125px"
            />
          )}
          <Box mb={isMobile ? "128px" : 0}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                "@media (min-width: 960px)": {
                  textAlign: "left",
                  fontSize: "24px",
                },
              }}
            >
              Зв’язатися з нами
            </Typography>
            <Box sx={{ display: "flex", gap: "20px", mt: "20px" }}>
              <Box
                component={"img"}
                src={telegramIcon}
                alt="telegram icon"
                width={isMobile ? "40px" : "62px"}
                sx={{ cursor: "pointer" }}
                onClick={() =>
                  window.open("https://t.me/legalist2442", "_blank")
                }
              />
              <Box
                component={"img"}
                src={instagramIcon}
                alt="instagram icon"
                width={isMobile ? "40px" : "62px"}
                sx={{ cursor: "pointer" }}
                onClick={() => window.open("https://www.instagram.com/kbelinskyi/", "_blank")}
              />
              <Box
                component={"img"}
                src={linkedinIcon}
                alt="linkedin icon"
                width={isMobile ? "40px" : "62px"}
                sx={{ cursor: "pointer" }}
                onClick={() => window.open("https://www.linkedin.com/in/kostia-belinskiy-b138b7269/", "_blank")}
              />
            </Box>
          </Box>
        </Box>
        <Box
          onClick={() => window.open('https://calendly.com/kostiantinople/30min?month=2025-09', '_blank')}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "58px",
            mb: isMobile ? "128px" : 0,
            cursor: "pointer",
          }}
        >
          <Box component={"img"} src={arrowUpIcon} alt="arrow up icon" />
          <Typography
            sx={{
              fontSize: "32px",
              fontWeight: 900,
              textAlign: "center",
              color: "rgba(215, 219, 226, 1)",
              textTransform: "uppercase",
              maxWidth: "272px",
              "@media (min-width: 960px)": { fontSize: "40px" },
            }}
          >
            вирішення проблем вище
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: isMobile ? "center" : "left",
            mb: isMobile ? "128px" : 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 600,
              mb: "14px",
              color: "rgba(11, 25, 62, 1)",
            }}
          >
            Меню
          </Typography>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              fontSize: "20px",
              fontWeight: 400,
              letterSpacing: "2%",
              lineHeight: "30px",
              color: "rgba(11, 25, 62, 1)",
              cursor: "pointer",
            }}
          >
            <li onClick={onScrollTo.header}>Головна</li>
            <li onClick={onScrollTo.services}>Послуги</li>
            <li onClick={windowInnerWidth < 640 ? onScrollTo.howWeWorkMobile : onScrollTo.howWeWorkDesktop}>Як ми працюємо</li>
            <li onClick={onScrollTo.whoWeWorkWith}>Клієнти</li>
            <li onClick={onScrollTo.aboutUs}>Чому ми?</li>
            <li onClick={onScrollTo.projects}>Кейси</li>
            <li onClick={onScrollTo.feedbacks}>Відгуки</li>
            <li onClick={onScrollTo.questions}>FAQ</li>
          </ul>
        </Box>

        <Box
          component="img"
          loading="lazy"
          alt="Logo"
          src={logoIcon}
          sx={{
            display: isMobile ? "block" : "none",
            mb: isMobile ? "40px" : 0,
            width: isMobile ? "125px" : "auto",
          }}
        />
      </Box>
    </footer>
  );
}
